import React from 'react';
import { objections } from '../../data/content';
import { SectionCTA } from '../SectionCTA';
export function Objections() {
  return <section className="w-full bg-cream px-4 py-16 sm:px-6 sm:py-20" data-id="element-250" data-mp="1w9qc6a0m33pk">
      <div className="mx-auto max-w-5xl" data-id="element-251" data-mp="2181l8ij31a6q">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-ink-muted" data-id="element-252" data-mp="21ae3kwsr5mkb">
          Be honest
        </p>
        <h2 className="mt-3 text-center font-display text-3xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-253" data-mp="2a997g28bqkkg">
          Does this sound familiar?
        </h2>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-254" data-mp="2f69jctruuhjh">
          {objections.map(item => <article key={item.quote} className="flex flex-col rounded-2xl border border-navy-100 bg-white p-5 shadow-soft" data-id="element-255" data-mp="2k158nm5piqsw">
              <span className="text-2xl" aria-hidden="true" data-id="element-256" data-mp="2tya0o2m8hghm">
                {item.emoji}
              </span>
              <h3 className="mt-3 font-display text-[17px] italic leading-snug text-navy-700" data-id="element-257" data-mp="2xytuoxbig3zj">
                “{item.quote}”
              </h3>
              <p className="mt-auto pt-3 text-[14px] leading-relaxed text-ink-soft" data-id="element-258" data-mp="3oymx2wgh3a46">
                {item.answer}
              </p>
            </article>)}
        </div>

        <div className="mx-auto mt-10 max-w-2xl rounded-3xl bg-white p-6 text-center shadow-soft" data-id="element-259" data-mp="3k13i1ubyatb6">
          <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-flag" data-id="element-260" data-mp="3f2ju5odsr7g6">
            If you said yes to even one of these…
          </p>
          <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-261" data-mp="bkrz214d67dr">
            You’re not necessarily missing more information. You may simply need a better way to
            organize the information you already have{' '}
            <strong className="font-bold text-ink" data-id="element-262" data-mp="1rkx6q8u19if">into a repeatable workflow.</strong>
          </p>
        </div>

        <SectionCTA transformation="Organize what you already know — starting today." label="Get the DVO Clinical Workflow Builder™" subline="$27 one-time · Instant digital access" data-id="element-263" data-mp="zaw4me144h7e" />
      </div>
    </section>;
}